<template>
  <div v-if="isDev" class="ui toggle checkbox">
    <input type="checkbox" id="impersonateCheckbox" v-model="isImpersonating" />
    <label for="impersonateCheckbox">Messaging Impersonate</label>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";

// Emits
const emit = defineEmits(["update:isImpersonating"]);

const STORAGE_KEY = "impersonateCheckboxState";

// Only show this as an option in dev
const isDev = globalThis.Bootstrap.Config.isDev;

// Initialize from localStorage, defaulting to false if not found
const isImpersonating = ref(false);
onMounted(() => {
  if (isDev && localStorage.getItem(STORAGE_KEY) === "true") {
    isImpersonating.value = true;
    emit("update:isImpersonating", true);
  }
});

watch(isImpersonating, newValue => {
  emit("update:isImpersonating", newValue);
  // Save to localStorage whenever the value changes
  localStorage.setItem(STORAGE_KEY, newValue.toString());
});
</script>

<style scoped></style>
